import { useCallback, useEffect, useMemo, useState } from 'react';

const normalizePayload = (values = {}) => ({
  usar_forecast: Boolean(values.usar_forecast),
  usar_equivalencia: Boolean(values.usar_equivalencia),
  es_base: Boolean(values.es_base),
  equivalencia: values.usar_equivalencia
    ? (values.equivalencia === '' || values.equivalencia === null || values.equivalencia === undefined
      ? null
      : Number(values.equivalencia))
    : null
});

export const useAdminAzucarGlass = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refreshToken, setRefreshToken] = useState(0);

  const fetchList = useCallback(async (signal) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch('/admin/api/azucar-glass', { signal });
      const data = await response.json();
      if (!response.ok || data?.error) {
        throw new Error(data?.error || 'No se pudieron obtener los artículos.');
      }
      if (!signal?.aborted) {
        setItems(data.items || []);
      }
    } catch (err) {
      if (!signal?.aborted) {
        setError(err?.message || 'Error al cargar artículos.');
      }
    } finally {
      if (!signal?.aborted) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    fetchList(controller.signal);
    return () => controller.abort();
  }, [fetchList, refreshToken]);

  const refresh = useCallback(() => {
    setRefreshToken((value) => value + 1);
  }, []);

  const saveItem = useCallback(async (id, values) => {
    const payload = normalizePayload(values);
    const response = await fetch(`/admin/api/azucar-glass/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    if (!response.ok || data?.error) {
      throw new Error(data?.error || 'No se pudieron guardar los cambios.');
    }
    return data?.item || null;
  }, []);

  return useMemo(() => ({
    items,
    loading,
    error,
    refresh,
    saveItem
  }), [items, loading, error, refresh, saveItem]);
};
